import type { IResourceItem, Action } from '@refinedev/core'

export const customTitleHandler = ({
  resource,
  action,
  params,
  pathname,
  autoGeneratedTitle,
}: {
  resource?: IResourceItem
  action?: Action
  params?: Record<string, string | undefined>
  pathname?: string
  autoGeneratedTitle: string
}) => {
  const appName = 'Requests Panel'
  let title = appName // Default title

  if (resource && action) {
    const resourceName = resource.name
      ? resource.name.charAt(0).toUpperCase() + resource.name.slice(1)
      : 'Resource'
    if (params?.id) {
      title = `${resourceName} #${params.id} | ${appName}`
    } else {
      title = `${resourceName} | ${appName}`
    }
  } else if (pathname === '/dashboard') {
    title = `Dashboard | ${appName}`
  } else if (pathname === '/login') {
    title = `Login | ${appName}`
  } else if (autoGeneratedTitle) {
    title = autoGeneratedTitle
  }

  return title
}
